// extracted by mini-css-extract-plugin
module.exports = {"text":"input_text__2NEWl","select":"input_select__30Hjd","hidden":"input_hidden__2tNXp","textArea":"input_textArea__2unsz"};